import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type CardVariant = 'default' | 'panel' | 'elevated' | 'accent';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  padding?: 'sm' | 'md' | 'lg' | 'none';
}

const variantClasses: Record<CardVariant, string> = {
  default: 'border border-stone-800 bg-stone-900',
  panel: 'border border-stone-800 bg-stone-925',
  elevated: 'border border-stone-700 bg-stone-800',
  accent: 'border border-amber-900/30 bg-amber-950/10',
};

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = 'default', padding = 'md', className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('rounded-md', variantClasses[variant], paddingClasses[padding], className)}
      {...rest}
    />
  );
});
